import type { BadgeVariant } from '@components/badge';

import { useStore } from 'models/Provider';

type IntegrationsResults = {
  [key: string]: {
    [key: string]: any;
  };
};

type Label = {
  variant: BadgeVariant;
  text: string;
};

export const useIntegrationLabels = (integrationsResults: IntegrationsResults) => {
  const { t } = useStore();
  let labels: Label[] = [];
  if (integrationsResults) {
    if ('hireflix' in integrationsResults) {
      if (integrationsResults.hireflix.status === 'sent') {
        labels.push({
          variant: 'orange',
          text: t('integrations.hireflix.application.status.sent'),
        });
      } else if (integrationsResults.hireflix.status === 'completed') {
        labels.push({
          variant: 'orange',
          text: t('integrations.hireflix.application.status.toevaluate'),
        });
      } else if (integrationsResults.hireflix.status === 'finalist') {
        labels.push({
          variant: 'green',
          text: t('integrations.hireflix.application.status.preselected'),
        });
      } else if (integrationsResults.hireflix.status === 'archived') {
        labels.push({
          variant: 'red',
          text: t('integrations.hireflix.application.status.discarded'),
        });
      }
    }
    if ('adManager' in integrationsResults) {
      if (integrationsResults.adManager.email !== '') {
        labels.push({
          variant: 'green',
          text: t('integrations.admanager.labels.created'),
        });
      }
    }
  }
  return labels;
};
